import { h } from 'vue';

export default {
    // functional: true,

    props:
    {
        page:
        {
            type: Object,
        },
    },


    render()
    {
        return h(
            'div',
            {
                // staticClass: data.staticClass,
            },
            [
                h(
                    'span',
                    this.page.total > 0
                        ? `Showing ${this.page.from} to ${this.page.to} of ${this.page.total} ${this.page.total > 1 ? 'records' : 'record'}`
                        : 'No record found'
                ),
            ]
        );
    },
};
